
























import {Component, Vue} from 'vue-property-decorator';
import {MutationList as rootMutations} from "@/store/modules/root/mutation-list";

@Component
export default class SideMenu extends Vue {

    private rootNamespace = 'root/';

    get sidebarShow(): boolean {
        return this.$store.getters[`${this.rootNamespace}isSidebarVisible`];
    }

    toggleSidebar() {
        this.$store.commit(`${this.rootNamespace}${rootMutations.TOGGLE_SIDEBAR}`);
    }

    routeHandler(e: any) {
        const destination = e.currentTarget.dataset.destination;
        this.toggleSidebar();
        this.$router.push(destination);
    }
}
